import apiRequest from "../ApiConfig";
import { WEBSERVICE } from "../CoreDataService";

// Public Apis //

export const generateCaptcha = () =>
  apiRequest(`${WEBSERVICE}generateCaptcha/200/300/50`);
export const deviceInformation = () =>
  apiRequest(
    `https://api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52`
  );

// Login Apis //
     
export const LoginWithUsernamePassword = (data) =>
  apiRequest(
    `${WEBSERVICE}user/LoginWithUsernamePassword`,
    "POST",
    data,
    false
  );
export const deviceVerification = (data) =>
  apiRequest(`${WEBSERVICE}user/deviceVerification`, "POST", data, false);
export const checkMfaStatus = (data) =>
  apiRequest(`${WEBSERVICE}user/checkMfaStatus`, "POST", data, false);
export const SendOtpLogin = (data) =>
  apiRequest(`${WEBSERVICE}user/SendOtp/login`, "POST", data, false);
export const resendDeviceVerificationMail = (data) =>
  apiRequest(
    `${WEBSERVICE}user/resendDeviceVerificationMail`,
    "POST",
    data,
    false
  );

//Notification //

export const updateFCMToken = (data) =>
  apiRequest(`${WEBSERVICE}notification/updateFCMToken`, "POST", data);

// User Details //

export const GetUserDetails = (data) =>
  apiRequest(`${WEBSERVICE}user/SendOtp/login`, "POST", data);
